import React from "react";

import TaxBudget from "@src/multiCustodian/components/Advisor/ClientProfile/Components/TaxBudget";

const AdvisorClientTaxBudget = () => <TaxBudget />;

export default AdvisorClientTaxBudget;
